export default "__VITE_ASSET__Dh5Co6cZ__"